import { Modal, Tabs } from "antd";
import { useService } from "pages/dashboard/alerts/service";
import { useEffect, useState } from "react";
import { SvgCarSmall, SvgHumanSmall, SvgLogo, SvgObjectSmall } from "ui/svgs";
import "./gpt-modal.scss";
import { softTitle } from "lib/utils";
function capitalizeFirstLetter(string: string): string {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function Card({ title, json, icon }) {
  function renderJson(value) {
    if (value instanceof Object) {
      return (
        <>
          {Object.entries(value).map(([key, value]: [any, any]) => {
            if (key === "bounding_box") return null;
            if (value === undefined) return null;
            return (
              <tr key={key}>
                <td>{key + ": "}</td>
                <td style={{ display: "inline-table" }}>{renderJson(value)}</td>
              </tr>
            );
          })}
        </>
      );
    } else {
      return value;
    }
  }
  return (
    <div
      style={{
        width: "388",
        backgroundColor: "rgba(250, 250, 250, 1)",
        borderRadius: "16px",
        padding: "16px",
      }}
    >
      <div style={{ display: "flex" }}>
        {icon}
        <span style={{ fontWeight: "600", marginLeft: "6px" }}>{title}</span>
      </div>
      {renderJson(json)}
    </div>
  );
}
const items = [
  {
    key: "1",
    label: "Cars",
  },
  {
    key: "2",
    label: "Humans",
  },
  {
    key: "3",
    label: "Objects",
  },
];
export default function GptAnalysisModal({ visible, onClose, alert }) {
  const [activeTab, setActiveTab] = useState("1");
  const { getSnapShotByAlertObj } = useService();
  const [snapShotSrc, setSnapShotSrc] = useState("");
  useEffect(() => {
    if (!alert) return;
    getSnapShotByAlertObj(alert)
      .then((data) => {
        setSnapShotSrc(URL.createObjectURL(data));
      })
      .catch((e) => console.error(e));
  }, [alert]);
  return (
    <Modal
      className="gpt-analysis-modal"
      open={visible}
      onCancel={onClose}
      cancelButtonProps={{
        className: "primaryButton bordered",
      }}
      cancelText="Close"
      okButtonProps={{ style: { display: "none" } }}
      title={<span className="title">AGI Analysis Results</span>}
      width={750}
    >
      {
        <div className="relative h-full aspect-video max-w-full max-h-full flex items-center justify-center">
          {snapShotSrc ? (
            <img src={snapShotSrc} className="video-aspect" width={592} />
          ) : (
            <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
              <SvgLogo width="80" className="fill-neutral-400" />
              <p className="text-neutral-400 font-semibold text-2xl">
                {softTitle()}
              </p>
            </div>
          )}
        </div>
      }

      <Tabs
        items={items}
        activeKey={activeTab}
        onChange={setActiveTab}
        centered={true}
        size={"large"}
      />
      {activeTab === "1" && (
        <>
          {!alert?.gptRaw?.cars?.length && (
            <div style={{ textAlign: "center" }}>No cars found</div>
          )}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "12px",
              maxHeight: "250px",
              overflow: "auto",
            }}
          >
            {alert?.gptRaw?.cars?.map((car, index) => {
              return (
                <Card
                  title={"Car " + (index + 1)}
                  icon={<SvgCarSmall />}
                  json={car}
                />
              );
            })}
          </div>
        </>
      )}
      {activeTab === "2" && (
        <>
          {!alert?.gptRaw?.people?.length && (
            <div style={{ textAlign: "center" }}>No humans found</div>
          )}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "12px",
              maxHeight: "250px",
              overflow: "auto",
            }}
          >
            {alert?.gptRaw?.people?.map((human, index) => {
              return (
                <Card
                  title={"Human " + (index + 1)}
                  icon={<SvgHumanSmall />}
                  json={human}
                />
              );
            })}
          </div>
        </>
      )}
      {activeTab === "3" && (
        <>
          {!alert?.gptRaw?.objects?.length && (
            <div style={{ textAlign: "center" }}>No objects found</div>
          )}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "12px",
              maxHeight: "250px",
              overflow: "auto",
            }}
          >
            {alert?.gptRaw?.objects?.map((object) => {
              return (
                <Card
                  title={`${capitalizeFirstLetter(object.name)}`}
                  icon={<SvgObjectSmall />}
                  json={{ ...object, name: undefined }}
                />
              );
            })}
          </div>
        </>
      )}
    </Modal>
  );
}
